import React, { useState, useEffect } from "react";
import {
  IonContent,
  IonGrid,
  IonModal,
  IonHeader,
  IonAlert,
  IonTitle,
  IonToolbar,
  IonRow,
  IonIcon,
  IonCol,
  IonButton,
  IonButtons,
} from "@ionic/react";
import { utilService } from "../../../services/utilService";
import { DoctorInfoReq } from "../Sms/Sms.model";
import { smsService } from "../Sms/Sms.service";
import { callOutline, closeCircleOutline } from "ionicons/icons";

import "./call.scss";
import CallUser from "./Components/CallUser/CallUser";
import { CapabilityTokenReq } from "./Call.model";
import { CallService } from "./Call.service";
import _ from "lodash";
import { useToast } from "@agney/ir-toast";
import { useNetwork } from "../../../helpers/NetworkContext";

interface callParams {
  selectedDoctorGuid?: string;
  isAssignedNumber?: boolean;
  dataFromParent?: any;
  isCallButton?: boolean;
  callButtonText?: string;
  disabled?: boolean;
  isPatient?: boolean;
  isUnit?: boolean;
  isNurse?: boolean;
  dataFromPatientCard?: any;
  isFromMessages?: any;
  listData?: any;
}
const ChatbotCall: React.FC<any> = (props) => {
  var [doctorInfoData, setDoctorInfoData]: any = useState([]);
  const [isShowCallModal, setIsShowCallModal] = useState(false);
  const [isShowCallUserModal, setIsShowCallUserModal] = useState(false);
  const [isPrimaryNumber, setIsPrimaryNumber] = useState(false);
  const [isShowAlert, setIsShowAlert] = useState(false);
  const [isSecondaryNUmberExist, setIsSecondaryNumberExist] = useState(false);
  const [capabilityTokenInfo, setCapabilityTokenInfo] = useState("");
  const Toast = useToast();
  const { selectedNetwork } = useNetwork();

  useEffect(() => {
    if (doctorInfoData.userData && doctorInfoData.userData.alternateNumber) {
      setIsSecondaryNumberExist(true);
    } else {
      setIsSecondaryNumberExist(false);
    }
  }, [doctorInfoData]);

  async function fetchDoctorInfo(params: DoctorInfoReq) {
    const respDoctorListResult: any = await smsService.getDoctorInformation(
      params
    );
    if (respDoctorListResult.isSuccess) {
      setDoctorInfoData(_.cloneDeep(respDoctorListResult.result));
      if (respDoctorListResult.result) {
        checkSecondaryNumberExists();
      }
    } else {

      smsService.handleErrorResponse();
    }
  }

  async function fetchAssignedContactInfo(params: DoctorInfoReq) {
    const respDoctorListResult: any =
      await smsService.getAssignedContactInformation(params);
    if (respDoctorListResult.isSuccess) {
      setDoctorInfoData(_.cloneDeep(respDoctorListResult.result));
      if (respDoctorListResult.result) {
        checkSecondaryNumberExists();
      }
    } else {

      smsService.handleErrorResponse();
    }
  }

  async function fetchCapabilityToken(params: CapabilityTokenReq) {
    const respCapabilityTokenResult: any =
      await CallService.getCapabilityTokenInformation(params);
    if (respCapabilityTokenResult.isSuccess) {
      setCapabilityTokenInfo(respCapabilityTokenResult.result);
      setIsShowCallUserModal(true);
    } else {

      CallService.handleErrorResponse();
    }
  }

  const checkSecondaryNumberExists = () => {
    if (!_.isEmpty(props.dataFromPatientCard)) {
      setIsShowAlert(true);
    } else {
      if (!props.isAssignedNumber) {
        setIsShowCallModal(true);
      } else {
        setIsShowAlert(true);
      }
    }
  };

  const paramsDoctorInfo = {
    guid: props.selectedDoctorGuid,
    reg_code: utilService.getNetwork(),
    n2n_network: props?.userNetwork ?? selectedNetwork?.value
  };

  const fetchAllDataFromApi = (isAppToAppCall: boolean) => {
    if (!_.isEmpty(props.dataFromPatientCard)) {
      if (props.isPatient) {
        const doctorInfoData: any = {
          userData: {
            mobileNumber:
              props.dataFromPatientCard?.patientDetails.contact_details[0]
                .number,
            firstName: props.dataFromPatientCard?.patientDetails.patient_name,
          },
        };
        setDoctorInfoData(doctorInfoData);
      } else if (props.isUnit) {
        const doctorInfoData: any = {
          userData: {
            mobileNumber:
              props.dataFromPatientCard?.unit.contactDetails[0].number,
            firstName: props.dataFromPatientCard?.unit.unitName,
          },
        };
        setDoctorInfoData(doctorInfoData);
      } else if (props.isNurse) {
        if (!props.dataFromPatientCard?.nurseContactDetails?.guid) {
          Toast.error("No assigned nurse available");
          return;
        }
        const doctorInfoData: any = {
          userData: {
            mobileNumber:
              props.dataFromPatientCard?.unit.contactDetails[0].number,
            firstName: props.dataFromPatientCard?.nurseContactDetails.name,
          },
        };
        setDoctorInfoData(doctorInfoData);
      }
    } else {
      if (props.isAssignedNumber) {
        if (!_.isEmpty(props.dataFromParent)) {
          const doctorInfoData: any = {
            userData: {
              mobileNumber: props.dataFromParent?.contactNumber,
              firstName: props.dataFromParent?.name,
            },
          };
          setDoctorInfoData(doctorInfoData);
        }
      }
    }

    paramsDoctorInfo.guid = isAppToAppCall ? paramsDoctorInfo.guid : "";
    if (isAppToAppCall) {
      // App-to-app (WebRTC) call: fetch the peer's info (for guid + name) and
      // open the call UI directly. The old flow called Twilio's capability-token
      // endpoint here, which isn't configured on this deployment, so the call
      // button silently did nothing. WebRTC needs no capability token.
      fetchDoctorInfoAndCall(paramsDoctorInfo);
    } else {
      fetchCapabilityToken(paramsDoctorInfo);
    }
  };

  async function fetchDoctorInfoAndCall(params: DoctorInfoReq) {
    const respDoctorListResult: any = await smsService.getDoctorInformation(
      params
    );
    if (respDoctorListResult.isSuccess && respDoctorListResult.result) {
      setDoctorInfoData(_.cloneDeep(respDoctorListResult.result));
      setIsShowCallUserModal(true);
    } else {
      smsService.handleErrorResponse();
    }
  }

  const initiateApiCall = () => {

    if (
      !_.isEmpty(props.dataFromParent) ||
      !_.isEmpty(props.dataFromPatientCard)
    ) {
      setIsShowAlert(true);
    } else {
      props.isAssignedNumber
        ? fetchAssignedContactInfo(paramsDoctorInfo)
        : fetchDoctorInfo(paramsDoctorInfo);
    }
    if (props?.handleClose) {
      props?.handleClose()
    }
    console.log("test call call guid ", props.selectedDoctorGuid)
  };

  return (
    <div className="call-container" onClick={(e) => e.stopPropagation()}>
      {
        props.isCallButton ?
          (
            <IonButton
              style={{ opacity: props?.disabled ? 0.4 : 1 }}
              disabled={props?.disabled}
              className="button secondary-transparent-btn btn-curved mr-2"
              onClick={() => {
                initiateApiCall();
              }}
            >
              <span className="icon-contact mr-2"></span>
              <span>{props.callButtonText}</span>
            </IonButton>
          )
          : (
            <div
              className={`icon-contact ${props.isHidden ? "msg-call-style" : "input-icon"} ${props.disabled ? "disabled-icon" : ""}`}
              onClick={() => {
                if (!props.disabled) {
                  initiateApiCall();
                }
              }}
            >
              <span className="call-label-msg">
                {props.isFromMessages ? "Call" : ""}
              </span>
            </div>
          )}

      <IonAlert
        isOpen={isShowAlert}
        onDidDismiss={() => setIsShowAlert(false)}
        cssClass="call-alert"
        header="Confirmation Message"
        message="Are you sure you want to call?"
        buttons={[
          {
            text: "NO",
            role: "cancel",
            cssClass: "secondary",
          },
          {
            text: "YES",
            handler: () => {
              setIsPrimaryNumber(true);
              fetchAllDataFromApi(false);
            },
          },
        ]}
      />
      <IonModal
        isOpen={isShowCallModal}
        backdropDismiss={false}
        className="call-modal"
      >
<IonHeader>
  <IonToolbar>
    <IonTitle className="header-msg">Call Preference</IonTitle>
    <IonButtons slot="end">
      <IonButton
        fill="clear"
        onClick={() => setIsShowCallModal(false)}
        className="close-btn"
      >
        <IonIcon icon={closeCircleOutline} />
      </IonButton>
    </IonButtons>
  </IonToolbar>
</IonHeader>

        {doctorInfoData && (
          <IonContent className="content-container">
            <IonRow
              className={`confirm-label ${!isSecondaryNUmberExist ? "confirm-label-padding" : ""
                }`}
            >
              {/* <IonCol> Are you sure you want to call?</IonCol> */}
            </IonRow>

            <IonGrid className="grid-container">
              {isSecondaryNUmberExist && (
                <IonRow className="call-with-label">
                  <IonCol>Call With</IonCol>
                </IonRow>
              )}

              <IonRow className="primary-button-row">
                <IonCol>
                  <IonButton
                    className="submit-btn button primary-btn primary-button"
                    shape="round"
                    onClick={() => {
                      setIsShowCallModal(false);
                      setIsPrimaryNumber(true);
                      fetchAllDataFromApi(false);
                    }}
                  >
                    <IonIcon slot="start" icon={callOutline} />
                    Primary Number
                  </IonButton>
                </IonCol>
              </IonRow>

              {isSecondaryNUmberExist && (
                <IonRow className="secondary-button-row">
                  <IonCol>
                    <IonButton
                      className="submit-btn button primary-btn secondary-button"
                      shape="round"
                      onClick={() => {
                        setIsShowCallModal(false);
                        setIsPrimaryNumber(false);
                        fetchAllDataFromApi(false);
                      }}
                    >
                      <IonIcon slot="start" icon={callOutline} />
                      Secondary Number
                    </IonButton>
                  </IonCol>
                </IonRow>
              )}

              <IonRow className="callCentral-button-row">
                <IonCol>
                  <IonButton
                    className="submit-btn button primary-btn callCentral-button"
                    shape="round"
                    onClick={() => {
                      setIsShowCallModal(false);
                      setIsPrimaryNumber(false);
                      fetchAllDataFromApi(true);
                    }}
                  >
                    <IonIcon slot="start" icon={callOutline} />
                    Nserix App
                  </IonButton>
                </IonCol>
              </IonRow>

              <IonRow
                className={`no-label ${!isSecondaryNUmberExist ? "no-label-padding" : ""
                  }`}
              >
                <IonCol>
                  <div
                    className="confirm-btn clickable no-button"
                    onClick={() => {
                      setIsShowCallModal(false);
                    }}
                  >
                    {/* NO */}
                  </div>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonContent>
        )}
      </IonModal>
      {(doctorInfoData.userData && isShowCallUserModal) && (
        <CallUser
          doctorInfoData={doctorInfoData}
          capabilityTokenData={capabilityTokenInfo}
          isShowCallUserModal={isShowCallUserModal}
          isPrimaryNumber={isPrimaryNumber}
          isAssignedNumber={props.isAssignedNumber}
          listData={props.listData}
          onOk={() => {
            setIsShowCallUserModal(false);
          }}
          onCancel={() => {
            setIsShowCallUserModal(false);
          }}
          userNetwork={props?.userNetwork}
        ></CallUser>
      )}
    </div>
  );
};

export default ChatbotCall;
